var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-launcher",
    {
      attrs: {
        avatar: _vm.avatar,
        agent: _vm.agent,
        "app-version": _vm.appVersion,
        "app-state": _vm.appState,
        "actions-type": _vm.actionsType,
        "is-initializing": !_vm.isReady || _vm.isInitializing,
        "is-loading-bundle": _vm.isLoadingBundle,
        "is-loading-settings": _vm.isLoadingLauncherSettings,
        "is-updating": _vm.isSavingSettings || _vm.isPreparingUpdate,
      },
      on: {
        "go-back": _vm.goToEnvRoot,
        "option-click": _vm.onOptionClick,
        save: _vm.onSaveAppLauncherSettings,
        update: _vm.onUpdateToTargetAppVersion,
        cancel: _vm.onClearChanges,
        "sign-out": function ($event) {
          return _vm.$emit("sign-out")
        },
      },
    },
    [
      _vm.showAppBundle
        ? _c(_vm.component, { tag: "component" })
        : _c("app-launcher-content", { attrs: { "app-state": _vm.appState } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }